

export class Stripe {
	static startPayment(transactionId, amount, currency, description, botContext, paymentCode) {
		const Message = botContext.getCapability("Message");
		const message = new Message({ addedByBot: true });

		message.stripeMessage([], { transactionId, amount, currency, description, paymentCode });
		botContext.tell(message);
	}
};
